const accordionList = document.querySelector('.accordion-list')

accordionList && (

    accordionList.addEventListener('click', (e) => {
        
        if(e.target.classList.contains('accordion-title')) {
            const accordionEl = e.target.closest('.accordion-item')
             
            if(accordionEl.classList.contains('is-active')) {
                accordionEl.classList.remove('is-active')
            } else {
                accordionEl.classList.add('is-active')
            }

        }
    })
)
